// src/services/settings/cron-schedule.service.js
import axios from "axios";
import { buildHeaders } from "../_headers.util";

const API_URL = `${process.env.VUE_APP_API_URL}settings/cron-schedules/`;

export default {
  getAll(params = {}) {
    return axios.get(API_URL, { params, headers: buildHeaders() });
  },
  create(data) {
    return axios.post(API_URL, data, { headers: buildHeaders() });
  },
  update(id, data) {
    return axios.put(`${API_URL}${id}`, data, { headers: buildHeaders() });
  },
  toggle(id) {
    return axios.post(
      `${API_URL}${id}/toggle`,
      {},
      { headers: buildHeaders() }
    );
  },
  bulkDelete(ids) {
    return axios.post(
      `${API_URL}bulk-delete`,
      { ids },
      { headers: buildHeaders() }
    );
  },
};
